import { useEffect, useState } from "react";

type Theme = "light" | "dark";
const STORAGE_KEY = "mrg-theme";

/**
 * Hook simples de tema. Aplica/remove classe "dark" no <html>.
 * Inicializa do localStorage; cai pra prefers-color-scheme se não tiver.
 */
export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    if (typeof window === "undefined") return "light";
    const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
    if (saved === "dark" || saved === "light") return saved;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // ignore
    }
    // Atualiza theme-color meta tag (status bar mobile)
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute("content", theme === "dark" ? "#0f172a" : "#2563eb");
    }
  }, [theme]);

  function toggle() {
    setThemeState((t) => (t === "dark" ? "light" : "dark"));
  }

  return { theme, toggle, setTheme: setThemeState };
}
